module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( isLoading ) { 
__p+='\n\n	<h3 class="count">Suchergebnisse</h3>\n\n	<div class="matches-list">\n		<ul>\n			<li>Einen Moment bitte...</li>\n		</ul>\n	</div>\n\n';
 } else { 
__p+='\n\n	<h3 class="count">'+
((__t=( paginationInfo ))==null?'':__t)+
'</h3>\n\n	';
 if ( results.length ) { 
__p+='\n		<div class="matches-list">\n			<ul>\n			';
 _.each(results, function(result) { 
__p+='\n				<li>\n					<a class="main" href="'+
((__t=( result.uri ))==null?'':__t)+
'">'+
((__t=( result.name ))==null?'':__t)+
'</a> ('+
((__t=( result.kategorie ))==null?'':__t)+
')<br>\n				</li>\n			';
 }); 
__p+='\n			</ul>\n		</div>\n	';
 } else { 
__p+='\n		<div class="notify">Für diesen Begriff wurde leider nichts gefunden.</div>\n	';
 } 
__p+='\n\n	<div class="paginator">\n		';
 if ( hasPrev ) { 
__p+='<a href="#" class="search-prev">&larr; '+
((__t=( __('prev') ))==null?'':__t)+
'</a>';
 } 
__p+='	\n		';
 if ( hasNext ) { 
__p+='<a href="#" class="search-next">'+
((__t=( __('next') ))==null?'':__t)+
' &rarr;</a>';
 } 
__p+='\n	</div>\n';
 } 
__p+='\n';
}
return __p;
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/mitch/jsapps/modules/reserva/templates/header/sitesearch-template.html
 ** module id = 53
 ** module chunks = 0
 **/